var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nivel > 2)?_c('EditaClasse',{attrs:{"idc":_vm.$route.params.idClasse}}):_c('EditaClasse12',{attrs:{"idc":_vm.$route.params.idClasse}})}
var staticRenderFns = []

export { render, staticRenderFns }